const translations = {
  fr: {
    nav: {
      dashboard: 'Tableau de bord',
      myCompany: 'Mon Entreprise',
      team: 'Opticiens',
      clients: 'Clients',
      quotes: 'Devis',
      invoices: 'Factures',
      expenseNotes: 'Notes de frais',
      supplierArchives: 'Archives Fournisseurs',
      accounting: 'Comptabilité',
      accountingReports: 'Rapports Comptables',
      siteStats: 'Statistiques site',
      subscriptions: 'Abonnements',
      settings: 'Paramètres',
    },
    header: {
      settings: 'Paramètres',
      logout: 'Déconnexion',
      professionalManagement: 'Gestion Professionnelle',
      configureProfile: 'Configurez votre profil',
    },
  },
  en: {
    nav: {
      dashboard: 'Dashboard',
      myCompany: 'My Company',
      team: 'Opticians',
      clients: 'Clients',
      quotes: 'Quotes',
      invoices: 'Invoices',
      expenseNotes: 'Expense Notes',
      supplierArchives: 'Supplier Archives',
      accounting: 'Accounting',
      accountingReports: 'Accounting Reports',
      siteStats: 'Site Statistics',
      subscriptions: 'Subscriptions',
      settings: 'Settings',
    },
    header: {
      settings: 'Settings',
      logout: 'Logout',
      professionalManagement: 'Professional Management',
      configureProfile: 'Set up your profile',
    },
  },
  es: {
    nav: {
      dashboard: 'Panel de control',
      myCompany: 'Mi Empresa',
      team: 'Ópticos',
      clients: 'Clientes',
      quotes: 'Presupuestos',
      invoices: 'Facturas',
      expenseNotes: 'Notas de gastos',
      supplierArchives: 'Archivos de Proveedores',
      accounting: 'Contabilidad',
      accountingReports: 'Informes Contables',
      siteStats: 'Estadísticas del sitio',
      subscriptions: 'Suscripciones',
      settings: 'Configuración',
    },
    header: {
      settings: 'Configuración',
      logout: 'Cerrar sesión',
      professionalManagement: 'Gestión Profesional',
      configureProfile: 'Configure su perfil',
    },
  },
};

export const t = (language, key) => {
  const keys = key.split('.');
  let result = translations[language] || translations.fr;
  for (const k of keys) {
    result = result?.[k];
    if (result === undefined) break;
  }
  return result || key;
};

export default translations;
